import { createContext, useContext } from "react";
import { NO_PROBLEMS, type ProblemIndex } from "../problem-model";

/** The problems of the workflow being edited, for every card, tile, step and exit that shows them. */
export const ProblemsContext = createContext<ProblemIndex>(NO_PROBLEMS);

export const useProblems = (): ProblemIndex => useContext(ProblemsContext);
